// Recurring-bill frequencies, kept in step with backend/utils/nextDueDateSql.js.
export const BILL_FREQUENCY_OPTIONS = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'biweekly', label: 'Every 2 weeks' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'bimonthly', label: 'Every 2 months' },
  { value: 'quarterly', label: 'Quarterly (every 3 months)' },
  { value: 'semi_annual', label: 'Semi-annual (every 6 months)' },
  { value: 'yearly', label: 'Yearly' },
  { value: 'custom', label: 'Custom interval...' },
];

export const INTERVAL_UNIT_OPTIONS = [
  { value: 'day', label: 'days' },
  { value: 'week', label: 'weeks' },
  { value: 'month', label: 'months' },
];

const LABELS = Object.fromEntries(BILL_FREQUENCY_OPTIONS.map((o) => [o.value, o.label]));
LABELS.annual = 'Yearly';
LABELS.one_time = 'One time';

export function billFrequencyLabel(bill) {
  if (!bill) return '';
  if (bill.frequency === 'custom') {
    const n = Number(bill.interval_count);
    const unit = bill.interval_unit;
    if (Number.isInteger(n) && n > 0 && unit) return `Every ${n} ${unit}${n === 1 ? '' : 's'}`;
    return 'Custom';
  }
  return LABELS[bill.frequency] || bill.frequency || '';
}
